
import { Svgs } from "./Images";
import { i18nManager } from "../i18n";


export enum PaymentMethod {

    USSD = "USSD",
    CARD = "CARD",
    WALLET = "WALLET",
    GIFT_CARD = "GIFT_CARD",
    MOBILE_MONEY = "MOBILE_MONEY",
    BANK_TRANSFER = "BANK_TRANSFER",

}

export const PaymentMethodAttributes = {
    [PaymentMethod.WALLET]: {
        icon: Svgs.Wallet,
        label: i18nManager.Labels.compound.payment_methods.wallet.label,
    },
    [PaymentMethod.USSD]: {
        icon: Svgs.USSD,
        label: i18nManager.Labels.compound.payment_methods.ussd.label,
    },
    [PaymentMethod.GIFT_CARD]: {
        icon: Svgs.GiftCard,
        label: i18nManager.Labels.compound.payment_methods.gift_card.label,
    },
    [PaymentMethod.CARD]: {
        icon: Svgs.Card,
        label: i18nManager.Labels.compound.payment_methods.card.label,
    },
    [PaymentMethod.MOBILE_MONEY]: {
        icon: Svgs.MobileMoney,
        label: i18nManager.Labels.compound.payment_methods.mobile_money.label,
    },
    [PaymentMethod.BANK_TRANSFER]: {
        icon: Svgs.BankTransfer,
        label: i18nManager.Labels.compound.payment_methods.bank_transfer.label,
    },
}
